import { checkUserRelations } from "./userRelations";
import { createDirectus, rest, readMe, staticToken } from '@directus/sdk'

export default defineNuxtRouteMiddleware(async (to, _from) => {
  const { fetchUser, setUser } = useDirectusAuth();
  const user = useDirectusUser();

  // ✅ PAGES PUBLIQUES (ajout de /register-lab-fc)
  const publicPaths = ['/login', '/no-access', '/register-lab-fc', '/health'];
  const isPublicPath = publicPaths.includes(to.path);

  // ÉTAPE 1 : AUTHENTIFICATION (priorité absolue - mais skip pour pages publiques)
  if (!isPublicPath) {
    if (!user.value) {
      const user = await fetchUser();
      setUser(user.value);
    }

    if (!user.value) {
      return navigateTo("/login");
    }
  }

  // ÉTAPE 2 : VÉRIFICATION DES RELATIONS (seulement pour pages protégées)
  if (!isPublicPath) {
    try {
      console.log('=== DEBUG MIDDLEWARE AUTH ===');
      console.log('Page cible:', to.path);

      const usersStore = useusersStore();
      let userWithRelations = usersStore.user;

      // Si le store n'a pas l'utilisateur avec relations, le récupérer
      if (!userWithRelations || !userWithRelations.dentsu_distributors_accesses) {
        console.log('Relations manquantes, récupération depuis Directus...');

        const token = useCookie('directus_token');
        if (token.value) {
          try {
            const directus = createDirectus('https://central.directus.app/')
              .with(rest())
              .with(staticToken(token.value));

            userWithRelations = await directus.request(
              readMe({
                // Champs explicites au lieu des wildcards. Ce middleware tourne
                // à CHAQUE navigation protégée (et 2x : SSR + client), c'est la
                // requête la plus fréquente de l'app. `*` tirait ~30 colonnes
                // inutiles (password, tfa_secret, theme_*) et
                // `dentsu_distributors_accesses.distributor.*` embarquait toute
                // la liste des POS du distributeur (jusqu'à 228 IDs).
                // Liste identique à components/login/index.vue : les deux
                // écrivent dans le MÊME usersStore.user, donc mêmes consommateurs
                // (checkUserRelations + bannières de pages/index.vue).
                fields: [
                  'id', 'first_name', 'last_name', 'email', 'status', 'role',
                  // accès distributeur : status (contrôle d'accès) + marketCode (hiérarchie)
                  'dentsu_distributors_accesses.id',
                  'dentsu_distributors_accesses.status',
                  'dentsu_distributors_accesses.level',
                  'dentsu_distributors_accesses.distributor.id',
                  'dentsu_distributors_accesses.distributor.title',
                  'dentsu_distributors_accesses.distributor.marketCode',
                  // accès POS : status + les champs affichés dans les bannières
                  'dentsu_pos_accesses.id',
                  'dentsu_pos_accesses.status',
                  'dentsu_pos_accesses.level',
                  'dentsu_pos_accesses.pos.id',
                  'dentsu_pos_accesses.pos.title',
                  'dentsu_pos_accesses.pos.posRank',
                  'dentsu_pos_accesses.pos.retailer_category',
                  'dentsu_pos_accesses.pos.retailer_type',
                  'dentsu_pos_accesses.pos.servicecenter',
                  // distributeurs directs : status (contrôle d'accès)
                  'dentsu_distributors.id',
                  'dentsu_distributors.status',
                  'dentsu_distributors.title',
                  'dentsu_distributors.marketCode',
                ]
              })
            );

            usersStore.user = userWithRelations;
            console.log('Relations récupérées et stockées:', userWithRelations);

          } catch (directusError) {
            console.error('Erreur récupération relations:', directusError);

            // CORRECTION ICI : Si erreur 401, problème d'auth → login
            if (directusError?.response?.status === 401) {
              console.log('Token invalide, redirection vers login');
              return navigateTo('/login');
            }

            // CORRECTION ICI : Pour autres erreurs, utiliser user de base
            // et laisser checkUserRelations() décider
            console.log('Utilisation user de base pour vérification relations');
            userWithRelations = user.value;
          }
        }
      }

      // ÉTAPE 3 : VÉRIFICATION FINALE DES RELATIONS
      if (userWithRelations) {
        const relationCheck = await checkUserRelations(userWithRelations);
        console.log('Relation check result:', relationCheck);

        // NOUVELLE PARTIE : Stocker les informations d'accès dans le state Nuxt
        const userAccess = useState('user.access', () => ({}));
        userAccess.value = {
          isAdmin: relationCheck.isAdmin,
          hasValidRelations: relationCheck.hasValidRelations,
          hasDistributorAccess: relationCheck.hasDistributorAccess,
          hasRetailerAccess: relationCheck.hasRetailerAccess,
          relationDetails: relationCheck.relationDetails,
          user: userWithRelations, // Stocker aussi l'utilisateur complet
          lastUpdated: new Date().toISOString()
        };

        console.log('User access stored in state:', userAccess.value);

        if (!relationCheck.hasValidRelations && !relationCheck.isAdmin) {
          console.log(`Navigation bloquée pour ${userWithRelations.email}: pas de relations actives`);
          return navigateTo('/no-access');
        } else {
          console.log('Relations OK, navigation autorisée');
        }
      } else {
        // CORRECTION ICI : Si vraiment impossible de récupérer user → problème auth
        console.log('Impossible de récupérer utilisateur, problème auth');
        return navigateTo('/login');
      }
    } catch (error) {
      // CORRECTION ICI : Erreur globale → problème auth
      console.error('Erreur vérification relations:', error);
      return navigateTo('/login');
    }
  }

  // ✅ Pour les pages publiques, laisser passer sans vérification
  console.log(`Accès public autorisé à: ${to.path}`);
});
